import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Famiglia } from 'src/app/shared/interfaces/custom/famiglia';
import { ServizioMenuService } from 'src/app/shared/services/servizio-menu.service';


@Component({
  selector: 'app-resturant-menu',
  templateUrl: './resturant-menu.component.html',
  styleUrls: ['./resturant-menu.component.scss'],
})
export class ResturantMenuComponent implements OnInit {
  resturantMenuCards: Famiglia[] = [];

  constructor(
    private servizioMenu: ServizioMenuService,
    private router: Router
  ) {}
  Routes 
  ngOnInit(): void {
    this.servizioMenu.getFamiglie().subscribe({
      next: (famiglie) => {
        this.resturantMenuCards = famiglie;
      },
      error: (error) => {
        console.error('Errore nel recupero delle famiglie:', error);
      },
    });
  }

  vaiAllaLista(codicefamiglia): void {
    this.router.navigate(['/menu', codicefamiglia]);
  }
}